'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowSync = function TiArrowSync(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 20.8c0-3.3-1-5.7-3.4-8.1-0.7-0.6-1.7-0.6-2.4 0-0.7 0.7-0.7 1.7 0 2.4 1.8 1.8 2.5 3.3 2.5 5.7 0 2.4-1 4.7-2.7 6.5-1.7 1.6-3.5 2.5-5.7 2.6l2-2.1c0.7-0.6 0.7-1.7 0-2.3s-1.7-0.7-2.3 0l-6.2 6.2 6.2 6.1c0.3 0.4 0.7 0.5 1.2 0.5s0.8-0.1 1.1-0.5c0.7-0.6 0.7-1.7 0-2.3l-2.2-2.2c3.2-0.2 5.9-1.4 8.2-3.7 2.4-2.3 3.7-5.5 3.7-8.8z m-21.7 0c0-2.4 1-4.7 2.7-6.4 1.7-1.7 3.5-2.6 5.8-2.7l-2.1 2.1c-0.7 0.7-0.7 1.7 0 2.4 0.3 0.3 0.7 0.5 1.1 0.5s0.9-0.2 1.2-0.5l6.2-6.2-6.2-6.2c-0.6-0.6-1.7-0.6-2.3 0s-0.7 1.7 0 2.4l2.1 2.2c-3.2 0.1-5.8 1.3-8.1 3.6-2.4 2.4-3.7 5.5-3.7 8.8 0 3.3 1 5.7 3.4 8.1 0.4 0.3 0.8 0.5 1.2 0.5s0.9-0.2 1.2-0.5c0.6-0.6 0.6-1.7 0-2.4-1.8-1.7-2.5-3.3-2.5-5.7z' })
        )
    );
};

exports.default = TiArrowSync;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-sync.js
// module id = 1801
// module chunks = 0